module.exports = __webpack_public_path__ + "img/reju3.ad9bbf3e.png";